import styled, { css } from 'styled-components'

import Panel from 'components/Panel'
import WorkspaceLogoUnstyled from 'modules/workspace/components/WorkspaceLogo'

export const StyledPanel = styled(Panel)`
  max-width: 520px;
  margin: auto;
`

export const Row = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
  display: grid;
  grid-template-columns: auto auto 50px;
`

export const Header = styled.span`
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  width: 100px;
`

export const OperationAndLogoContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const WorkspaceLogo = styled(WorkspaceLogoUnstyled)`
  margin-top: 12px;
`

export const LinkedWorkspacesAvatarsContainer = styled.div`
  display: flex;
  margin-top: 12px;
`

const LinkedWorkspaceLogoStyle = css`
  /* All avatars but first one */
  & ~ &:nth-child(n + 1) {
    margin-left: -8px;
  }

  /* Only the last avatar */
  & ~ &:last-child {
    margin-right: 8px;
  }
`

export const LinkedWorkspaceLogo = styled(WorkspaceLogoUnstyled)`
  ${LinkedWorkspaceLogoStyle}
`

export const LinkedWorkspaceNames = styled.span`
  flex: 1;
`

export const ExtraWorkspaceLogo = styled(WorkspaceLogo.Wrapper)`
  margin-left: -8px;

  background-color: ${({ theme }) => theme.colors.orange};
  color: ${({ theme }) => theme.colors.text.light.base};
`

export const ExtraWorkspaceAvatarPlaceholder = styled.div<{
  hasMoreThanNineWorkspaces: boolean
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ hasMoreThanNineWorkspaces }) =>
    hasMoreThanNineWorkspaces ? '0.75rem' : '0.875rem'};
`
